(() => {
  if (window.__tmpV3FinalStabilityReady) return;
  window.__tmpV3FinalStabilityReady = true;

  const CLOTHING_SECTION = 'body.index-template [data-id$="featured_collection_TY37YX"]';
  const MODAL_ID = 'TmpClothingQuickAdd';

  const rootUrl = () => ((window.Shopify?.routes?.root || '/').replace(/\/?$/, '/'));
  const esc = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[char]);
  const productUrlFromCard = (card) => card?.querySelector('a[href*="/products/"]')?.href || '';
  const handleFromUrl = (url) => {
    try {
      return decodeURIComponent(new URL(url, location.origin).pathname.match(/\/products\/([^/?#]+)/)?.[1] || '');
    } catch (_) {
      return '';
    }
  };

  const dispatchCartRefresh = (payload) => {
    document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: payload } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  };

  const addVariant = async (id) => {
    const response = await fetch(`${rootUrl()}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: String(id), quantity: 1 }] })
    });
    const payload = await response.json();
    if (!response.ok || payload?.status) {
      throw new Error(payload?.description || payload?.message || 'Could not add this product.');
    }
    dispatchCartRefresh(payload);
    return payload;
  };

  const ensureModal = () => {
    let modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'tmp-clothing-quick-add';
    modal.hidden = true;
    modal.innerHTML = `
      <button class="tmp-clothing-quick-add__overlay" type="button" data-close aria-label="Close"></button>
      <div class="tmp-clothing-quick-add__panel" role="dialog" aria-modal="true" aria-labelledby="TmpClothingQuickAddTitle">
        <button class="tmp-clothing-quick-add__close" type="button" data-close aria-label="Close">×</button>
        <p class="tmp-clothing-quick-add__eyebrow">QUICK ADD</p>
        <h2 id="TmpClothingQuickAddTitle" class="tmp-clothing-quick-add__title"></h2>
        <p class="tmp-clothing-quick-add__hint">CHOOSE YOUR SIZE</p>
        <div class="tmp-clothing-quick-add__variants" data-variants></div>
        <p class="tmp-clothing-quick-add__status" data-status aria-live="polite"></p>
      </div>`;
    document.body.appendChild(modal);

    const close = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('tmp-quick-add-open');
    };

    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-close]')) close();
    });

    modal.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-variant-id]');
      if (!button || button.disabled) return;
      const status = modal.querySelector('[data-status]');
      const buttons = [...modal.querySelectorAll('[data-variant-id]')];
      buttons.forEach((item) => { item.disabled = true; });
      button.classList.add('is-loading');
      if (status) status.textContent = 'Adding to cart…';
      try {
        await addVariant(button.dataset.variantId);
        close();
      } catch (error) {
        if (status) status.textContent = error.message || 'Could not add this size.';
        buttons.forEach((item) => {
          if (item.dataset.available === 'true') item.disabled = false;
        });
      } finally {
        button.classList.remove('is-loading');
      }
    });

    return modal;
  };

  const openClothingQuickAdd = async (productUrl) => {
    const handle = handleFromUrl(productUrl);
    if (!handle) {
      location.assign(productUrl);
      return;
    }

    const modal = ensureModal();
    const title = modal.querySelector('.tmp-clothing-quick-add__title');
    const variantsRoot = modal.querySelector('[data-variants]');
    const status = modal.querySelector('[data-status]');
    modal.hidden = false;
    document.documentElement.classList.add('tmp-quick-add-open');
    if (title) title.textContent = 'LOADING…';
    if (variantsRoot) variantsRoot.innerHTML = '';
    if (status) status.textContent = '';

    try {
      const response = await fetch(`${rootUrl()}products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Could not load product options.');
      const product = await response.json();
      const variants = Array.isArray(product.variants) ? product.variants : [];
      if (!variants.length) throw new Error('No variants available.');
      if (title) title.textContent = product.title || 'CHOOSE YOUR SIZE';

      if (variants.length === 1) {
        if (!variants[0].available) throw new Error('This item is sold out.');
        await addVariant(variants[0].id);
        modal.hidden = true;
        document.documentElement.classList.remove('tmp-quick-add-open');
        return;
      }

      if (variantsRoot) {
        variantsRoot.innerHTML = variants.map((variant) => {
          const available = Boolean(variant.available);
          const label = variant.title && variant.title !== 'Default Title' ? variant.title : 'One size';
          return `<button type="button" class="tmp-clothing-quick-add__variant${available ? '' : ' is-soldout'}" data-variant-id="${esc(variant.id)}" data-available="${available}" ${available ? '' : 'disabled'}>${esc(label)}${available ? '' : ' — SOLD OUT'}</button>`;
        }).join('');
      }
    } catch (error) {
      modal.hidden = true;
      document.documentElement.classList.remove('tmp-quick-add-open');
      console.error('[TMP clothing quick add]', error);
      location.assign(productUrl);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(`${CLOTHING_SECTION} .product-card__atc`);
    if (!button || button.disabled) return;
    const productUrl = productUrlFromCard(button.closest('.product-card'));
    if (!productUrl) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openClothingQuickAdd(productUrl);
  }, true);

  const hide = (element) => {
    if (!element) return;
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
  };

  const showCartQuickAdd = (element) => {
    if (!element) return;
    element.hidden = false;
    element.removeAttribute('hidden');
    element.removeAttribute('aria-hidden');
    element.style.removeProperty('display');
    element.style.removeProperty('visibility');
    element.style.removeProperty('opacity');
    element.style.removeProperty('pointer-events');
    const form = element.closest('form');
    if (form) {
      form.hidden = false;
      form.removeAttribute('hidden');
      form.removeAttribute('aria-hidden');
      form.style.removeProperty('display');
      form.style.removeProperty('visibility');
      form.style.removeProperty('opacity');
    }
  };

  const sanitizeProductCardMedia = (card) => {
    if (!card) return;
    const wrapper = card.querySelector('.product-card__image-wrapper');
    const anchor = wrapper?.querySelector(':scope > a[href*="/products/"]');
    const motion = anchor?.querySelector(':scope > motion-element');
    const mainMedia = motion?.querySelector(':scope > .product-card__image--main');

    if (motion && mainMedia) {
      [...motion.children].forEach((child) => {
        if (child !== mainMedia) hide(child);
      });
      mainMedia.style.setProperty('display', 'block', 'important');
      mainMedia.style.setProperty('opacity', '1', 'important');
      mainMedia.style.setProperty('visibility', 'visible', 'important');
    }

    if (anchor && motion) {
      [...anchor.children].forEach((child) => {
        if (child !== motion) hide(child);
      });
    }

    card.querySelectorAll(
      '.product-card__image--second,.product-card__swatches,.product-card__swatch,[class*="gpo"][class*="swatch"],[class*="globo"][class*="swatch"]'
    ).forEach(hide);
  };

  const sanitizeEmptyCartCard = (card) => {
    const link = card?.querySelector('.tmp-empty-cart-bestseller__media-link');
    if (!link) return;
    const images = [...link.querySelectorAll('img')];
    if (!images.length) return;

    const mainImage = link.querySelector(':scope > img[loading="lazy"]') ||
      link.querySelector(':scope > img') ||
      images.find((image) => !image.closest('[class*="swatch"], [class*="variant"]')) ||
      images[0];

    mainImage.classList.add('tmp-empty-cart-bestseller__main-image');
    mainImage.style.setProperty('display', 'block', 'important');
    mainImage.style.setProperty('opacity', '1', 'important');
    mainImage.style.setProperty('visibility', 'visible', 'important');
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');

    images.forEach((image) => {
      if (image !== mainImage) hide(image);
    });
    card.querySelectorAll('[class*="swatch"], [class*="variant-thumb"], [class*="variant-image"]').forEach((element) => {
      if (!element.contains(mainImage)) hide(element);
    });
  };

  const enforceSinglePdpAtc = () => {
    if (!document.body?.classList.contains('product-template')) return;

    document.querySelectorAll('[class*="sticky-atc"],sticky-atc-bar,#shopify-section-sticky-atc-bar').forEach(hide);
    document.querySelectorAll('#MainContent .product-card__actions,#MainContent .product-card__main-actions,#MainContent .product-card__atc').forEach((element) => {
      if (element.closest('.section--related-products')) return;
      hide(element);
    });

    const promoShade = Boolean(document.querySelector(
      '#MainContent [data-tmp-bundle-root],#MainContent [data-tmp-bundle-template],#MainContent .tmp-meller-offer'
    ));
    const builder = document.querySelector('#MainContent .tmp-meller-offer .tmp-meller-cta');
    const standardAtc = document.querySelector('#MainContent .tmp-standard-native-atc .product-form__submit[name="add"]');

    if (promoShade && builder) {
      document.querySelectorAll('#MainContent button[name="add"],#MainContent .product-form__submit').forEach((button) => {
        if (button !== builder && !button.closest('.tmp-meller-offer') && !button.closest('.section--related-products')) hide(button);
      });
      [...document.querySelectorAll('#MainContent .tmp-meller-cta')].slice(1).forEach(hide);
      return;
    }

    if (standardAtc) {
      const productButtons = [...document.querySelectorAll('#MainContent button[name="add"],#MainContent .product-form__submit')]
        .filter((button) => !button.closest('.product-card,quick-view-modal,.quick-view,.tmp-meller-offer'));
      productButtons.forEach((button) => {
        if (button !== standardAtc) hide(button);
      });
    }
  };

  const stabilizeBestsellers = () => {
    document.querySelectorAll(
      'body.product-template .tmp-home-bestsellers-row .product-card,body.product-template .section--related-products .product-card,#CartDrawer .product-card'
    ).forEach(sanitizeProductCardMedia);
    document.querySelectorAll('#CartDrawer .tmp-empty-cart-bestseller').forEach(sanitizeEmptyCartCard);
    document.querySelectorAll('#CartDrawer .cart-item:not(:last-child) > .cart-drawer-products-recommendation').forEach(hide);
    document.querySelectorAll(
      '#CartDrawer .cart-drawer-products-recommendation .product-card__atc,#CartDrawer .tmp-empty-cart-bestseller__atc'
    ).forEach(showCartQuickAdd);
  };

  let scheduled = false;
  const run = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enforceSinglePdpAtc();
      stabilizeBestsellers();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  document.addEventListener('cart:refresh', () => setTimeout(run, 40));
  document.addEventListener('product-ajax:added', () => setTimeout(run, 40));
  document.addEventListener('recommendations:loaded', run);
  document.addEventListener('variant:changed', run);
  document.addEventListener('shopify:section:load', run);

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();

/* V4 PDP related products: keep the real quick-add controls visible after the legacy one-CTA stability pass. */
(() => {
  if (window.__tmpV4RelatedQuickAddVisible) return;
  window.__tmpV4RelatedQuickAddVisible = true;

  const STYLE_ID = 'TmpV4RelatedQuickAddStyles';
  const ensureStyle = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      html body.product-template #MainContent .section--related-products .product-card__actions.product-card__main-actions,
      html body.product-template #MainContent .section--related-products form.product-card__actions.product-card__main-actions {
        display:flex!important;
        opacity:1!important;
        visibility:visible!important;
        transform:none!important;
        pointer-events:auto!important;
        z-index:12!important;
      }
      html body.product-template #MainContent .section--related-products .product-card__atc {
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        opacity:1!important;
        visibility:visible!important;
        pointer-events:auto!important;
      }
      html body.product-template #MainContent .section--related-products .product-card__atc-icon {
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        opacity:1!important;
        visibility:visible!important;
      }
    `;
    document.head.appendChild(style);
  };

  let scheduled = false;
  const reveal = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      if (!document.body?.classList.contains('product-template')) return;
      ensureStyle();

      document.querySelectorAll('#MainContent .section--related-products .product-card__actions, #MainContent .section--related-products .product-card__main-actions').forEach((element) => {
        element.hidden = false;
        element.removeAttribute('hidden');
        element.removeAttribute('aria-hidden');
        element.style.setProperty('display', 'flex', 'important');
        element.style.setProperty('opacity', '1', 'important');
        element.style.setProperty('visibility', 'visible', 'important');
        element.style.setProperty('transform', 'none', 'important');
        element.style.setProperty('pointer-events', 'auto', 'important');
        element.style.setProperty('z-index', '12', 'important');
      });

      document.querySelectorAll('#MainContent .section--related-products .product-card__atc').forEach((button) => {
        button.hidden = false;
        button.removeAttribute('hidden');
        button.removeAttribute('aria-hidden');
        button.style.setProperty('display', 'inline-flex', 'important');
        button.style.setProperty('opacity', '1', 'important');
        button.style.setProperty('visibility', 'visible', 'important');
        button.style.setProperty('pointer-events', 'auto', 'important');
      });

      document.querySelectorAll('#MainContent .section--related-products .product-card__atc-icon').forEach((icon) => {
        icon.hidden = false;
        icon.removeAttribute('hidden');
        icon.removeAttribute('aria-hidden');
        icon.style.setProperty('display', 'inline-flex', 'important');
        icon.style.setProperty('opacity', '1', 'important');
        icon.style.setProperty('visibility', 'visible', 'important');
      });
    });
  };

  const delayedReveal = () => {
    reveal();
    setTimeout(reveal, 0);
    setTimeout(reveal, 80);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', delayedReveal, { once: true });
  } else {
    delayedReveal();
  }
  document.addEventListener('recommendations:loaded', delayedReveal);
  document.addEventListener('shopify:section:load', delayedReveal);
  document.addEventListener('variant:changed', delayedReveal);
  document.addEventListener('cart:refresh', delayedReveal);
  new MutationObserver(delayedReveal).observe(document.documentElement, { childList: true, subtree: true });
})();
